import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import PrivateDashboard from "../../components/privateDashboard/PrivateDashboard";
import GroupDashboard from "../../components/groupDashboard/GroupDashboard";
import './productPage.css'

const ProductPage = () => {
  const { productCode } = useParams();
  const { data, headerIndexes } = useSelector((state) => state.data);

  if (!data || !headerIndexes) return <div>Loading...</div>;

  const decodedProductCode = decodeURIComponent(productCode).trim().toLowerCase();

  // Get relevant column indexes
  const productCodeIndex = headerIndexes["Product Code"]; // Private
  const taskNameIndex = headerIndexes["Task Name"]; // Group
  const typeIndex = headerIndexes["TYPE (labels)"];

  if (typeIndex === undefined || taskNameIndex === undefined) {
    return <div>Error: Required data is missing.</div>;
  }

  // Separate data for Private and Group tours
  const privateTourData = [];
  const groupTourData = [];

  data.forEach((row) => {
    const tourType = row[typeIndex]?.trim();
    
    if (tourType === "Private" && productCodeIndex !== undefined) {
      if (row[productCodeIndex]?.trim().toLowerCase() === decodedProductCode) {
        privateTourData.push(row); // Push full row
      }
    } else if (tourType === "Group" && typeof row[taskNameIndex] === "string") {
      // ✅ Normalize Task Name: Remove extra spaces, trim, and lowercase
      const normalizedTaskName = row[taskNameIndex].replace(/\s+/g, " ").trim().toLowerCase();
      
      if (normalizedTaskName.includes(decodedProductCode)) {
        groupTourData.push(row); // Push full row
      }
    }
  });

  return (
    <div className="productPage Wrapper">
      <h2>Details for Product Code: {decodedProductCode.toUpperCase()}</h2>

      {privateTourData.length > 0 && <PrivateDashboard data={privateTourData} headerIndexes={headerIndexes} />}
      {groupTourData.length > 0 && <GroupDashboard data={groupTourData} headerIndexes={headerIndexes} />}
      
      {privateTourData.length === 0 && groupTourData.length === 0 && <p>No data found for this product.</p>}
    </div>
  );
};

export default ProductPage;
